import { cloneDeep } from 'lodash';
import { getSettingValue_TemplateId } from './tabSettingsHelper';
import { saveStatus } from 'Shared/Utils/constants/commonConsts';

export const setStatusSavedRecursive = (tabs) => {
  if (tabs === undefined) return tabs;

  return tabs.map((tab) => {
    let newTab = {
      ...tab,
      status: tab.status ? saveStatus.SAVED : undefined,
      subtabSettings: setStatusSavedRecursive(tab.subtabSettings)
    };
    if (tab.inLineTabTemplate) {
      newTab = {
        ...newTab,
        inLineTabTemplate: {
          ...tab.inLineTabTemplate,
          subtabSettings: setStatusSavedRecursive(
            tab.inLineTabTemplate?.subtabSettings
          )
        }
      };
    }

    return newTab;
  });
};

export const setPropsOnTemplateTabsSettingsRecursively = (tabs) => {
  let result = tabs ? cloneDeep(tabs) : [];
  return result.map((e, key) => ({
    ...e,
    sortOrder: key,
    internalId: key,
    defaultActive: true,
    tabTemplateId: getSettingValue_TemplateId(e.settings),
    subtabSettings: setPropsOnTemplateTabsSettingsRecursively(
      e.subtabSettings
    ).map((ts, ts_key) => ({
      ...ts,
      internalId: ts_key
    }))
  }));
};

export const setPropsOnTemplateTabsRecursively = (tabs) => {
  let result = tabs ? cloneDeep(tabs) : [];
  return result.map((e, key) => ({
    ...e,

    sortOrder: key,
    internalId: key,
    inLineTabTemplate: {
      ...e.inLineTabTemplate,
      tabTemplateId: e.inLineTabTemplate
        ? getSettingValue_TemplateId(e.inLineTabTemplate.settings)
        : undefined,
      subtabSettings: e.inLineTabTemplate
        ? setPropsOnTemplateTabsSettingsRecursively(
            e.inLineTabTemplate.subtabSettings
          )
        : setPropsOnTemplateTabsSettingsRecursively(e.subtabSettings)
    },
    subtabSettings: setPropsOnTemplateTabsRecursively(e.subtabSettings)
  }));
};
